import styled from '@emotion/styled';
import { fontSize } from '@styles/globalStyles';

export const Form = styled.form``;

export const Title = styled.div`
  text-align: center;
  margin-bottom: 56px;
`;

export const FilesRow = styled.div`
  display: flex;
  gap: 8px;
`;

export const Agreements = styled.fieldset`
  margin: 70px 0 36px;
`;

export const FieldInputWrapper = styled.div<{ error: boolean; isDragActive: boolean }>`
  position: relative;
  flex: 1;
  text-align: center;
  padding: 24px 16px;
  box-shadow: ${({ theme, isDragActive }) =>
    isDragActive ? '0 4px 10px 0 rgba(0, 159, 227, 0.497)' : theme.shadow.small};
  border: 1px solid ${({ error, theme }) => (error ? theme.colors.borders.invalid : 'transparent')};
  background-color: ${({ isDragActive }) => (isDragActive ? '#f7f7f8' : '#ffffff')};
  transition: all 0.3s ease-in-out;
`;

export const UploadInfo = styled.p`
  margin-top: 10px;
  font-size: ${fontSize(12)};

  & + & {
    margin-top: 15px;
  }
`;

export const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.colors.borders.invalid};
  font-size: ${fontSize(12)};
  position: absolute;
  left: 0;
  bottom: -20px;
`;

export const SelectedFile = styled.div`
  margin-top: 15px;
  color: ${({ theme }) => theme.colors.link.primary};
  font-size: ${fontSize(12)};
  display: flex;
  align-items: center;
  text-align: left;
`;

export const SelectedFileIcon = styled.div`
  flex: 0 0 24px;
`;
